import { useMemo } from 'react';
import { getNavIcon } from '@/lib/navigation-icons';
import { useNavigationApi, resolveNodeRoute, resolveIcon, type NavigationLink } from './useNavigationApi';
import {
  LayoutDashboard,
  Compass,
  Truck,
  LifeBuoy,
  Award,
  Megaphone,
  UserCog,
  type LucideIcon,
} from 'lucide-react';

export interface SidebarLink {
  title: string;
  url: string;
  icon: LucideIcon;
}

const mockQuickLinks: SidebarLink[] = [
  { title: "Dashboard", url: "/", icon: LayoutDashboard },
  { title: "Showroom", url: "/parts", icon: Compass },
  { title: "Fleet", url: "/units", icon: Truck },
  { title: "Aftercare", url: "/dealer-claims", icon: LifeBuoy },
  { title: "Rewards", url: "/my-spiffs", icon: Award },
  { title: "Hub", url: "/message-board", icon: Megaphone },
  { title: "My Account", url: "/contact-info", icon: UserCog },
];

export function useSidebarNavigation() {
  const { nodes, isLoading, useMock } = useNavigationApi({
    rootNavigationTag: 'QuickLinks',
  });

  const apiLinks = useMemo<SidebarLink[] | null>(() => {
    if (!nodes) return null;
    return nodes
      .filter((node: any) => node.showInMenu !== false)
      .map((node: any) => {
        const title = node.name || '';
        return {
          title,
          url: resolveNodeRoute(node),
          icon: resolveIcon(node.navigationTag),
        };
      });
  }, [nodes]);

  return {
    quickLinks: useMock ? mockQuickLinks : (apiLinks ?? []),
    isLoading,
    isMock: useMock,
  };
}
